import { useEffect, useRef } from 'react';
import { useConfig } from '@browsing/config';
import { getQueryParam } from '@browsing/utils';
import { fetchDataLayer } from '../../api/tracking';
import { getElementFromTrafficSource, toPageTypeLvl1 } from '../../helpers';
import { tracker } from '../track';
export const useTrackPageView = ({ page, earlyAccessPhase, earlyAccessState, isLoaded, }) => {
    const config = useConfig();
    const tracked = useRef(false);
    useEffect(() => {
        /**
         * We need to reset `tracked` ref whenever `configSku` changes
         * in order to track every article view on PDP after client-side navigation.
         */
        if (config.isEnabled('ga4') && isLoaded) {
            tracked.current = false;
        }
    }, [config, isLoaded]);
    useEffect(() => {
        if (!isLoaded || tracked.current) {
            return;
        }
        if (!config.isEnabled('ga4')) {
            return;
        }
        tracked.current = true;
        const trafficSource = getQueryParam('trafficSource');
        let phase = (earlyAccessPhase === null || earlyAccessPhase === void 0 ? void 0 : earlyAccessPhase.toLowerCase()) || null;
        if (earlyAccessState === 'ACTIVE') {
            phase = 'early_access';
        }
        else if (earlyAccessState === 'EXPIRED') {
            phase = 'general_access';
        }
        fetchDataLayer().then(({ dataLayer, lead }) => {
            tracker.track('GA4-page_view', Object.assign(Object.assign({}, dataLayer), { event_name: 'page_view', pagetype_lvl_1: toPageTypeLvl1(page), pagetype_lvl_2: null, pagetype_lvl_3: null, page_view: {
                    context: null,
                    element: getElementFromTrafficSource(trafficSource),
                }, browser_size: `${window.innerWidth}x${window.innerHeight}`, screen_color: `${window.screen.colorDepth}-bit`, screen_resolution: `${window.screen.width}x${window.screen.height}`, early_access_phase: phase }));
            if (lead) {
                tracker.track('GA4-lead', {
                    event_name: 'lead',
                    lead: {
                        method: dataLayer.method,
                    },
                });
            }
        });
    }, [config, earlyAccessPhase, earlyAccessState, isLoaded, page]);
};
